import { render, staticRenderFns } from "./DuplicateBoardModal.vue?vue&type=template&id=5be8f012"
import script from "./DuplicateBoardModal.vue?vue&type=script&lang=js"
export * from "./DuplicateBoardModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports